var ajax = require('./extrax2-webadmin.ajax.js');

function registerAuthEvents() {

	$("#password_forgotten").click(function (e) {
		e.preventDefault();

		$("#login_user").fadeOut("slow", function () {
			$("#login_reset_password").fadeIn("slow", function () {
				$("#username_reset").focus();
			});
		});
	});

	$("#password_remembered").click(function (e) {
		e.preventDefault();

		$("#login_reset_password").fadeOut("slow", function () {
			$("#login_user").fadeIn("slow", function () {
				$("#username").focus();
			});
		});
	});

	$("#goto_login").click(function (e) {
		e.preventDefault();

		$("#message_reset_password").fadeOut("slow", function () {
			$("#login_user").fadeIn("slow", function () {
				$("#username").focus();
			});
		});
	});

	$("#reset_password").click(function (e) {
		e.preventDefault();

		ajax.ajaxCall($(this).attr('action'), $(this).attr('method'), $('#login_reset_password').serialize(), false, function (data) {
			if (data === '') {
				$("#login_reset_password").fadeOut("slow", function () {
					$("#message_reset_password").fadeIn("slow", function () {
					});
				});
			} else {
				$('.error-reset-password').text(trans('extrax2-webadmin.error_reset_password_' + data));
				$("#error_reset_password").removeAttr('hidden');
			}
		});
	});
}

module.exports.registerAuthEvents = registerAuthEvents;
